import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SavedCartItemsComponent } from './saved-cart-items.component';
import { AuthGuard, CmsConfig, provideConfig } from '@spartacus/core';
import { ReviewItemsComponent } from '../../../../../checkout/b2b/components/checkout-review-submit/components/review-items/review-items.component';

@NgModule({
  declarations: [SavedCartItemsComponent],
  imports: [CommonModule, ReviewItemsComponent],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        SavedCartItems: {
          component: SavedCartItemsComponent,
          guards: [AuthGuard],
        },
      },
    }),
  ],
})
export class SavedCartItemsModule {}
